/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRotateCw = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.048 3c1.954.01 3.882.735 5.51 2.003l.268.217L20 7.865V4h2v7h-7V9l3.237-.001-2.692-2.243c-1.255-1.046-2.733-1.667-4.208-1.747L11 5c-4.172 0-7.428 3.62-6.954 7.819.355 3.138 2.896 5.721 6.024 6.122a7.007 7.007 0 0 0 7.322-4.082l.1-.234 1.853.75a9.006 9.006 0 0 1-9.529 5.55c-4.043-.519-7.3-3.828-7.757-7.882-.599-5.299 3.443-9.89 8.679-10.04z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRotateCw as RotateCw };
